/* lua.js generated code 0.3.0 */

require("clover/panelBusLogic/PaymentLimitLogic")
var UserDealPayTypeBase = xClass("UserDealPayTypeBase")
UserDealPayTypeBase.prototype.canBuyGoods = function (goodsId, num) {
    var self = this
    return [false, ZooErrorCode.BUY_WRONG_MONEY_TYPE]
}
UserDealPayTypeBase.prototype.isAppInstall = function () {
    var self = this
    return true
}
UserDealPayTypeBase.prototype.buyGoods = function (goodsId, num, targetId, param, onSuccess, onFail, onCancel) {
    var self = this
    /* 	-- 参照PaymentBase.lua PaymentBase:payCallback()

	result = {
	    tradeId = goodsInfo.tradeId
	    orderId = goodsInfo.tradeId
	    goodsInfo = goodsInfo
	    payType = self.parentType or self.type
	    subPayType = self.type
	    stage = stage
	    resultType = PayResultType.kError|PayResultType.kSuccess|PayResultType.kCancel
    	subPayType = Payments.ALI_QUICK_PAY optional
    	code=0 if resultType == PayResultType.kError
    	msg="" if resultType == PayResultType.kError
	}
	 */
    var paymentType = self.getPaymentsType()
    var goodsInfo = self.getGoodsInfo(goodsId, num)
    function payCallback(result) {
        cc.log(">>>>>>android payment callback")
        cc.log(table.tostring(result))
        if (result && type(result) === "table") {
            if (result.resultType === PayResultType.kSuccess) {
                // 将用户标志为付费用户并更新付费时间
                var extend = UserManager.getInstance().getUserExtendRef()
                extend.setPayUser(true)
                extend.setLastPayTime(Localhost.time())
                if (onSuccess) {
                    onSuccess(result)
                }
                SyncManager.getInstance().sync()
            } else if (result.resultType === PayResultType.kError) {
                if (onFail) {
                    result.data = result.code
                    onFail(result)
                }
            } else if (onCancel) {
                onCancel()
            }
        } else if (onFail) {
            onFail(table([1, "data", ZooErrorCode.kInvalidParams]))
        }
    }
    printf("buyGoods:%s", paymentType)
    PaymentBase.buyWithType(paymentType, goodsInfo, payCallback)
}
// @param goodsId
// @param goodsType --没什么用了，
// return {
//		goodsType = goodsType, --没什么用了，
//    	goodsIdInfo = goodsIdInfo, --@see GoodsIdInfoObject
//    	amount = 1,
//    	totalFee = 4,--实际要支付的钱，单位（元）
//      goodsName = "", 商品名称（可选，由具体支付方式给出）
// }
UserDealPayTypeBase.prototype.getGoodsInfo = function (goodsId, amount) {
    var self = this
    amount = amount || 1
    var goodsType = 1
    var goodsIdInfo = GoodsIdInfoObject.create(goodsId, goodsType)
    var goods = MetaManager.getInstance().getGoodsMeta(goodsId)
    var price = PaymentManager.getPriceByPaymentType(goodsId, goodsType, self.getPaymentsType())
    var goodsInfo = table(
        [1, "goodsType", goodsType],
        [1, "goodsIdInfo", goodsIdInfo],
        [1, "amount", amount],
        [1, "totalFee", price * amount]
    )
    return goodsInfo
}
UserDealPayTypeBase.prototype.getPaymentsType = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return Payments.UNSUPPORT
}
module.exports = UserDealPayTypeBase
